import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { InfoBoxBase } from './info-box-base';

@Component({
  selector: 'app-info-box-new',
  imports: [FontAwesomeModule],
  templateUrl: './info-box-new.html',
  styleUrl: './info-box-shared.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoBoxNew extends InfoBoxBase {
}
